export default "__VITE_ASSET__CrHhKAra__"